var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "a_infor", class: { open: _vm.isOpen } },
    [
      _c(
        "p",
        {
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [_vm._v("附件")]
      ),
      _c("div", { staticClass: "box fj" }, [
        _vm.canUpload
          ? _c("p", [
              _vm._v("上传合同"),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("（必传）")
              ])
            ])
          : _c("p", [_vm._v("合同附件")]),
        _vm.canUpload
          ? _c(
              "div",
              [
                _c(
                  "mt-button",
                  {
                    attrs: { size: "small", plain: "", icon: "upload" },
                    on: {
                      click: function($event) {
                        return _vm.ChooseFiles(1)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        slot: "icon",
                        src: require("@/assets/upload.png"),
                        height: "25",
                        width: "25"
                      },
                      slot: "icon"
                    }),
                    _vm._v(" 上传 ")
                  ]
                ),
                _c("br"),
                _c(
                  "span",
                  { staticStyle: { "font-size": "10px", color: "gray" } },
                  [_vm._v("支持扩展名：.jpg .doc .pdf...")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.ContractList && _vm.ContractList.length > 0
          ? _c(
              "ul",
              _vm._l(_vm.ContractList, function(item, index) {
                return _c("li", { key: index }, [
                  _c("p", { staticClass: "longText" }, [
                    _vm._v(
                      "上传人：" +
                        _vm._s(item.uploaderName) +
                        " 上传日期：" +
                        _vm._s(_vm.getDateStr(item.createDateTime))
                    )
                  ]),
                  _c(
                    "p",
                    {
                      on: {
                        click: function($event) {
                          return _vm.GoToAttach(item)
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            float: "left",
                            background: "none",
                            color: "black",
                            "margin-left": "5px",
                            padding: "0"
                          }
                        },
                        [_vm._v("合同附件：")]
                      ),
                      _vm._v(" " + _vm._s(item.displayName) + " "),
                      _vm.deletable
                        ? _c(
                            "span",
                            {
                              staticClass: "ydd",
                              on: {
                                click: function($event) {
                                  return _vm.DeleteThis(item.index)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              }),
              0
            )
          : _vm._e(),
        _c("div", { staticClass: "clear" })
      ]),
      _c("div", { staticClass: "box fj" }, [
        _vm.canUpload
          ? _c("p", [
              _vm._v("法务邮件审批"),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("（必传）")
              ])
            ])
          : _c("p", [_vm._v("法务邮件审批")]),
        _vm.canUpload
          ? _c(
              "div",
              [
                _c(
                  "mt-button",
                  {
                    attrs: { size: "small", plain: "", icon: "upload" },
                    on: {
                      click: function($event) {
                        return _vm.ChooseFiles(3)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        slot: "icon",
                        src: require("@/assets/upload.png"),
                        height: "25",
                        width: "25"
                      },
                      slot: "icon"
                    }),
                    _vm._v(" 上传 ")
                  ]
                ),
                _c("br"),
                _c(
                  "span",
                  { staticStyle: { "font-size": "10px", color: "gray" } },
                  [_vm._v("支持扩展名：.jpg .doc .pdf...")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.LegalLit && _vm.LegalLit.length > 0
          ? _c(
              "ul",
              _vm._l(_vm.LegalLit, function(item, index) {
                return _c("li", { key: index }, [
                  _c("p", { staticClass: "longText" }, [
                    _vm._v(
                      "上传人：" +
                        _vm._s(item.uploaderName) +
                        " 上传日期：" +
                        _vm._s(_vm.getDateStr(item.createDateTime))
                    )
                  ]),
                  _c(
                    "p",
                    {
                      on: {
                        click: function($event) {
                          return _vm.GoToAttach(item)
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(item.displayName) + " "),
                      _vm.deletable
                        ? _c(
                            "span",
                            {
                              staticClass: "ydd",
                              on: {
                                click: function($event) {
                                  return _vm.DeleteThis(item.index)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              }),
              0
            )
          : _vm._e(),
        _c("div", { staticClass: "clear" })
      ]),
      _c("div", { staticClass: "box fj" }, [
        _vm.canUpload
          ? _c("p", [
              _c("span", [_vm._v("营业执照附件")]),
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v("（必传）")
              ])
            ])
          : _c("p", [_vm._v("营业执照附件")]),
        _vm.canUpload
          ? _c(
              "div",
              [
                _c(
                  "mt-button",
                  {
                    attrs: { size: "small", plain: "", icon: "upload" },
                    on: {
                      click: function($event) {
                        return _vm.ChooseFiles(4)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        slot: "icon",
                        src: require("@/assets/upload.png"),
                        height: "25",
                        width: "25"
                      },
                      slot: "icon"
                    }),
                    _vm._v(" 上传 ")
                  ]
                ),
                _c("br"),
                _c(
                  "span",
                  { staticStyle: { "font-size": "10px", color: "gray" } },
                  [_vm._v("支持扩展名：.jpg .doc .pdf...")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.LicenseList && _vm.LicenseList.length > 0
          ? _c(
              "ul",
              _vm._l(_vm.LicenseList, function(item, index) {
                return _c("li", { key: index }, [
                  _c("p", { staticClass: "longText" }, [
                    _vm._v(
                      "上传人：" +
                        _vm._s(item.uploaderName) +
                        " 上传日期：" +
                        _vm._s(_vm.getDateStr(item.createDateTime))
                    )
                  ]),
                  _c(
                    "p",
                    {
                      on: {
                        click: function($event) {
                          return _vm.GoToAttach(item)
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(item.displayName) + " "),
                      _vm.deletable
                        ? _c(
                            "span",
                            {
                              staticClass: "ydd",
                              on: {
                                click: function($event) {
                                  return _vm.DeleteThis(item.index)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              }),
              0
            )
          : _vm._e(),
        _c("div", { staticClass: "clear" })
      ]),
      _c("div", { staticClass: "box fj" }, [
        _c("p", [_vm._v("其他附件")]),
        _vm.canUpload
          ? _c("div", [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "mt-button",
                    {
                      attrs: { size: "small", plain: "", icon: "upload" },
                      on: {
                        click: function($event) {
                          return _vm.ChooseFiles(2)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          slot: "icon",
                          src: require("@/assets/upload.png"),
                          height: "25",
                          width: "25"
                        },
                        slot: "icon"
                      }),
                      _vm._v(" 上传 ")
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-left": "5px",
                        display: "flex",
                        background: "#e0e0e0",
                        "border-radius": "1rem"
                      },
                      on: {
                        click: function($event) {
                          return _vm.ShouPup()
                        }
                      }
                    },
                    [
                      _c("input", {
                        staticStyle: {
                          background: "#e0e0e0",
                          border: "0",
                          padding: "0.5rem 1rem",
                          "border-radius": "1rem",
                          color: "#595858",
                          width: "70%"
                        },
                        attrs: { readonly: "" },
                        domProps: { value: _vm.attachType.className }
                      }),
                      _c("img", {
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          src: require("@/assets/dropdown.png"),
                          width: "18",
                          height: "13"
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _c(
                "span",
                { staticStyle: { "font-size": "10px", color: "gray" } },
                [_vm._v("支持扩展名：.jpg .doc .pdf...")]
              )
            ])
          : _vm._e(),
        _vm.AttachFileList && _vm.AttachFileList.length > 0
          ? _c(
              "ul",
              _vm._l(_vm.AttachFileList, function(item, index) {
                return _c("li", { key: index }, [
                  _c("p", { staticClass: "longText" }, [
                    _vm._v(
                      "上传人：" +
                        _vm._s(item.uploaderName) +
                        " 上传日期：" +
                        _vm._s(_vm.getDateStr(item.createDateTime))
                    )
                  ]),
                  _c(
                    "p",
                    {
                      staticClass: "longText",
                      on: {
                        click: function($event) {
                          return _vm.GoToAttach(item)
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            float: "left",
                            background: "none",
                            color: "black",
                            "margin-left": "5px",
                            padding: "0"
                          }
                        },
                        [_vm._v(_vm._s(item.typeName) + "：")]
                      ),
                      _vm._v(" " + _vm._s(item.displayName) + " "),
                      _vm.deletable
                        ? _c(
                            "span",
                            {
                              staticClass: "ydd",
                              on: {
                                click: function($event) {
                                  return _vm.DeleteThis(item.index)
                                }
                              }
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              }),
              0
            )
          : _vm._e(),
        _c("div", { staticClass: "clear" })
      ]),
      _c("input", {
        staticStyle: { display: "none" },
        attrs: { type: "file", id: "file-input" }
      }),
      _c(
        "mt-popup",
        {
          staticStyle: { width: "100%" },
          attrs: {
            "popup-transition": "popup-fade",
            closeOnClickModal: "true",
            position: "bottom"
          },
          model: {
            value: _vm.popupVisible,
            callback: function($$v) {
              _vm.popupVisible = $$v
            },
            expression: "popupVisible"
          }
        },
        [
          _c(
            "mt-picker",
            {
              staticStyle: { width: "100%" },
              attrs: {
                slots: _vm.slots,
                "value-key": "className",
                showToolbar: ""
              },
              on: { change: _vm.onValuesChange }
            },
            [
              _c("div", { staticClass: "picker-toolbar-title" }, [
                _c(
                  "div",
                  {
                    staticClass: "mint-datetime-action mint-datetime-cancel",
                    on: {
                      click: function($event) {
                        _vm.popupVisible = !_vm.popupVisible
                      }
                    }
                  },
                  [_vm._v("关闭")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "mint-datetime-action mint-datetime-confirm",
                    on: { click: _vm.confirmSelect }
                  },
                  [_vm._v("确定")]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }